<template></template>

<script>
export default {
    props: {
        options: {
            type: Object,
            required: false,
        }
    },

    mounted() {
        if (!! this.options) {
            window.Swal
                .fire(this.options)
                .then((result) => {
                    try {
                        if (result.isConfirmed && !! this.options.confirmButtonUrl) {
                            window.location.href = this.options.confirmButtonUrl;
                        } else if (result.isDenied && !! this.options.denyButtonUrl) {
                            window.location.href = this.options.denyButtonUrl;
                        } else if (result.isDismissed && !! this.options.cancelButtonUrl) {
                            window.location.href = this.options.cancelButtonUrl;
                        }
                    } catch (e) {
                        // ignore ...
                    }
                });
        }
    }
}
</script>
